import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import TermService from "../../services/term/TermService";
import { loadingTermDropdown } from "../../store/slices/term/termSlice";

export const useTerm = () => {
  const dispatch: AppDispatch = useDispatch();

  const { termDropdown } = useSelector(
    (state: RootState) => state.term
  );

  const fetchTermDropdown = async () => {
    try {
      const response = await TermService.fetchDropdown();
      dispatch(loadingTermDropdown(response));
    } catch (error) {
      console.error("Error al cargar terms:", error);
    }
  };

  return {
    termDropdown,
    fetchTermDropdown,
  };
};
